export const SET_USER = "SET_USER";
export const RESET_USER = "RESET_USER";
export const AUTH_FETCH_START = "AUTH_FETCH_START";
export const AUTH_FETCH_SUCCESS = "AUTH_FETCH_SUCCESS";
export const AUTH_FETCH_FAILURE = "AUTH_FETCH_FAILURE";
export const RESET_ERROR = "RESET_ERROR";

const AuthReducer = (state, action) => {
  switch (action.type) {
    case AUTH_FETCH_START: {
      return { ...state, loading: true };
    }
    case AUTH_FETCH_FAILURE: {
      return { ...state, error: action.payload, loading: false };
    }
    case AUTH_FETCH_SUCCESS: {
      return { ...state, loading: false, error: null };
    }
    case SET_USER:
      return { ...state, currentUser: action.payload, loading: false, error: null };
    case RESET_USER:
      return { ...state, currentUser: null };
    case RESET_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};

export default AuthReducer;
